import { useEffect, useState, type FormEvent } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { getFirebaseAuth } from "@/auth/firebase";
import { useAuth } from "@/auth/useAuth";
import { colors } from "@/theme/colors";

export function Login() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const from = (loc.state as { from?: string } | null)?.from ?? "/";

  useEffect(() => {
    if (!loading && user) nav(from, { replace: true });
  }, [user, loading, nav, from]);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await signInWithEmailAndPassword(getFirebaseAuth(), email, password);
    } catch (e) {
      setErr(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: colors.shell,
      }}
    >
      <form
        onSubmit={onSubmit}
        style={{
          width: 360,
          background: colors.panel,
          border: `1px solid ${colors.line}`,
          borderRadius: "var(--radius-md)",
          padding: "var(--space-roomy)",
          display: "flex",
          flexDirection: "column",
          gap: "var(--space-base)",
        }}
      >
        <h1
          style={{
            fontSize: "var(--fs-title)",
            lineHeight: "var(--lh-title)",
            marginBottom: 0,
          }}
        >
          Marcador Natura
        </h1>
        <label style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <span style={{ fontSize: "var(--fs-ui)", color: colors.textMuted }}>
            Email
          </span>
          <input
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={inputStyle}
          />
        </label>
        <label style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <span style={{ fontSize: "var(--fs-ui)", color: colors.textMuted }}>
            Senha
          </span>
          <input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyle}
          />
        </label>
        {err && <div style={{ color: colors.danger }}>{err}</div>}
        <button type="submit" disabled={busy} style={primaryBtn}>
          {busy ? "Entrando…" : "Entrar"}
        </button>
      </form>
    </div>
  );
}

const inputStyle: React.CSSProperties = {
  padding: "8px 10px",
  background: colors.panel,
  border: `1px solid ${colors.line}`,
  borderRadius: "var(--radius-sm)",
  fontFamily: "var(--font-body)",
  fontSize: "var(--fs-body)",
  color: colors.text,
};

const primaryBtn: React.CSSProperties = {
  background: colors.primary,
  color: colors.onPrimary,
  border: "none",
  borderRadius: "var(--radius-sm)",
  padding: "10px 16px",
  fontSize: "var(--fs-body)",
  fontWeight: 600,
  cursor: "pointer",
};
